import isEqual from 'lodash/isEqual';
import { TSearchParams } from './TSearchParams';

type TLoadType = 'incremental' | 'full';

export enum LoadType {
    incremental = 'incremental',
    full = 'full',
}

export const deriveLoadType = (
    previousParams: TSearchParams | null,
    newParams: TSearchParams,
): TLoadType => {
    if (!newParams.machineType) {
        return LoadType.full;
    }

    if (!previousParams) {
        return LoadType.full;
    }

    const { amount: previousAmount, ...pParams } = previousParams;
    const { amount: newAmount, ...nParams } = newParams;

    if (!isEqual(pParams, nParams)) {
        return LoadType.full;
    }

    return previousAmount < newAmount ? LoadType.incremental : LoadType.full;
};
